import React from 'react';
import './WhatsAppButton.css';
import Logo from '../assets/WhatsApp.avif';

const WhatsAppButton = () => (
  <a
    href="https://wa.me/573142376242"
    target="_blank"
    rel="noopener noreferrer"
    className="whatsapp-float"
    title="Escríbenos por WhatsApp"
  >
    <img
      src={Logo}
      alt="WhatsApp"
      className="whatsapp-icon"
    />
  </a>
);

export default WhatsAppButton;
